import { render } from "./aboutme.vue?vue&type=template&id=47494cb8"
import script from "./aboutme.vue?vue&type=script&lang=js"
export * from "./aboutme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__